import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule, Routes } from '@angular/router';
import { NgClickOutsideDirective, NgClickOutsideExcludeDirective } from 'ng-click-outside2';
import { provideCharts, ThemeService, withDefaultRegisterables } from 'ng2-charts';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FeatureFlagModule } from '../directives/featureFlag.module';
import { FeatureFlagGuardFn } from '../guards/featureFlagGuard.service';
import { AlertDialogComponent } from '../modal/alert-dialog/alert-dialog.component';
import { ModalContainerModule } from '../modal/modal-container/modal-container.module';
import { PatientPrioritySortPipe } from '../pipes/patient-priority-sort.pipe';
import { SharedPipesModule } from '../pipes/shared-pipes.module';
import { TimeAgoPipe } from '../pipes/time-ago.pipe';
import { AvaSelectModule } from '../shared/ava-select';
import { AutomationsComponent } from './automations/automations.component';
import { AvaContributionDialogComponent } from './ava-contribution/ava-contribution-dialog/ava-contribution-dialog.component';
import { AvaContributionComponent } from './ava-contribution/ava-contribution.component';
import { AvaPatientCardComponent } from './avafollowup/ava-patient/ava-patient.component';
import { AvafollowupComponent } from './avafollowup/avafollowup.component';
import { ListFilterPipe } from './avafollowup/list-filter.pipe';
import { BrandRecallDialogComponent } from './avafollowup/modal/brand-recall-dialog/brand-recall-dialog.component';
import { WinModal } from './avafollowup/modal/win-modal/win-modal.component';
import { TeamDecisionComponent } from './avafollowup/team-decision/team-decision.component';
import { CasepresentationComponent } from './casepresentation/casepresentation.component';
import { ChatDashboardComponent } from './chat-dashboard/chat-dashboard.component';
import { ContactDetails } from './chat-dashboard/modal/contact-details/contact-details';
import { ContactViewTranscript } from './chat-dashboard/modal/contact-view-transcript/contact-view-transcript';
import { CardCheckboxComponent } from './modal/card-checkbox/card-checkbox.component';
import { DialogVCWins } from './modal/dialog-vc-wins/dialog-vc-wins';
import { LaunchViewComponent } from './modal/launch-view/launch-view.component';
import { DialogBookingDetailsComponent } from './newpatientscheduler/modal/dialog-booking-details.component';
import { NewpatientschedulerComponent } from './newpatientscheduler/newpatientscheduler.component';
import { TrackerCommunicationDialogComponent } from './newpatienttracker/modal/tracker-communication-dialog.component';
import { NewPatientTrackerTableComponent } from './newpatienttracker/new-patient-tracker-table/new-patient-tracker-table.component';
import { NewpatientTrackerComponent } from './newpatienttracker/newpatienttracker.component';
import { SurveyReportComponent } from './newpatienttracker/survey-report/survey-report.component';
import { TrackerSearchComponent } from './newpatienttracker/tracker-search/tracker-search.component';
import { PatientfollowupComponent } from './patientfollowup/patientfollowup.component';
import { RcmDashboardComponent } from './rcm-dashboard/rcm-dashboard.component';
import { DialogDataExampleDialog } from './virtualconsult/modal/dialog-data-example-dialog';
import { VirtualconsultComponent } from './virtualconsult/virtualconsult.component';

const routes: Routes = [
  {
    path: '',
    component: AutomationsComponent,
    children: [
      { path: 'ava-followup', component: AvafollowupComponent },
      {
        path: 'chat-dashboard',
        component: ChatDashboardComponent,
        canActivate: [FeatureFlagGuardFn],
        data: { FeatureFlag: ['ava-chat'] },
      },
      { path: 'virtual-consult', component: VirtualconsultComponent },
      { path: 'new-patient-scheduler', component: NewpatientschedulerComponent },
      { path: 'new-patient-tracker', component: NewpatientTrackerComponent },
      { path: 'case-presentation', component: CasepresentationComponent },
      { path: 'patient-follow-up', component: PatientfollowupComponent },
      { path: 'rcm-dashboard', component: RcmDashboardComponent },
      { path: '', redirectTo: 'ava-followup', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  declarations: [
    VirtualconsultComponent,
    NewpatientschedulerComponent,
    DialogBookingDetailsComponent,
    AutomationsComponent,
    NewpatientTrackerComponent,
    CasepresentationComponent,
    PatientfollowupComponent,
    AvafollowupComponent,
    DialogDataExampleDialog,
    DialogVCWins,
    TrackerCommunicationDialogComponent,
    ListFilterPipe,
    AvaPatientCardComponent,
    TeamDecisionComponent,
    WinModal,
    LaunchViewComponent,
    CardCheckboxComponent,
    ChatDashboardComponent,
    ContactDetails,
    ContactViewTranscript,
    SurveyReportComponent,
    AvaContributionComponent,
    AvaContributionDialogComponent,
    AlertDialogComponent,
    TrackerSearchComponent,
    NewPatientTrackerTableComponent,
    RcmDashboardComponent,
    BrandRecallDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatTableModule,
    MatSortModule,
    MatSelectModule,
    MatInputModule,
    MatProgressBarModule,
    NgScrollbarModule,
    NgClickOutsideDirective,
    NgClickOutsideExcludeDirective,
    ModalContainerModule,
    SharedPipesModule,
    MatIconModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatButtonModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatBadgeModule,
    MatListModule,
    OverlayModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatTreeModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSliderModule,
    MatSlideToggleModule,
    AvaSelectModule,
    FeatureFlagModule,
    MatCardModule,
    MatExpansionModule,
    TimeAgoPipe,
  ],
  providers: [
    DatePipe,
    PatientPrioritySortPipe,
    ThemeService,
    provideCharts(withDefaultRegisterables()),
  ],
  exports: [SurveyReportComponent, AvaContributionDialogComponent],
})
export class AutomationsModule {}
